import React from 'react';
import PropTypes from 'prop-types';
import CardDropdown from '../../../../../components/common/CardDropdown';
import Flex from '../../../../../components/common/Flex';
import { Badge, Card, Col, FormLabel, Row } from 'react-bootstrap';
import ParadasNoAutorizadasVehiculoChart from './ParadasNoAutorizadasVehiculoChart';
import FalconCardFooterLink from '../../../../../components/common/FalconCardFooterLink';
import classNames from 'classnames';
import FalconCardHeader from '../../../../../components/common/FalconCardHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'; // 
import IconButton from '../../../../../components/common/IconButton';
import { useState } from 'react';
import { obtenerIconoVehiculo } from '../../../../../components/common/google-maps-selector/IconosTabla';

const ParadasNoAutorizadasVehiculo = ({ data, onSelectAlertType, highlightedAlertType, handleFiltro, highlightedParadaNoAuth }) => {

    //Estados del componente 
    const [verDetalle, setVerDetalle] = useState(true);

    if (!Array.isArray(data) || data.length === 0) {
        return null; // Se Evita renderizar si no hay datos
    }

    // Agrupar alertas por id_vehiculo  y calcular total de cada una
    const alertasMap = {};
    data.forEach(alert => {
        if (!alertasMap[alert.id_vehiculo]) {
            alertasMap[alert.id_vehiculo] = {
                id: alert.id_vehiculo,
                id_vehiculo: alert.id_vehiculo,
                title: alert.no_economico,
                target: 0,
                img: alert.icono_alerta,
                amount: 0,
                color: alert.color_vehiculo, // Se recibe el color desde el padre; antes alert.color ahora se toma del vehiculo
                tipo_vehiculo: alert.tipo_vehiculo,
                color_vehiculo: alert.color_vehiculo
            };
        }
        alertasMap[alert.id_vehiculo].target += 1;
    });

    // Convertir el mapa a un array
    const alertasFormatted = Object.values(alertasMap);

    // Calcular el total de eventos para obtener los porcentajes
    const totalEventos = alertasFormatted.reduce((sum, alert) => sum + alert.target, 0);
    alertasFormatted.forEach(alert => {
        alert.amount = totalEventos > 0 ? ((alert.target / totalEventos) * 100).toFixed(1) : 0;
    });

    //Calcular el total de vehiculos -----------------------------------------------------------------------
    const cantVehicles = alertasFormatted.length;

    // 🔹 Ordenar por cantidad de alertas (de mayor a menor)
    alertasFormatted.sort((a, b) => b.target - a.target);

    // 🔹 Obtener solo los 10 primeros elementos
    const top10Alertas = alertasFormatted;//.slice(0, 10);

    let filteredData = null;

    if (highlightedAlertType) {
        filteredData = top10Alertas.filter((item) => item.id_vehiculo == highlightedAlertType)
    }

    //Titulo del Card de informacion ----------------------------------------------------------------------
    let titleHeader = '';

    //Ambos filtros seleccionados (Tipo Alerta y vehiculo)
    if (highlightedParadaNoAuth && highlightedAlertType) {
        titleHeader = `Paradas no autorizadas: ${highlightedParadaNoAuth} - ${filteredData[0].title}`;
    }
    //Unicamenete seleccionado Tipo de alerta
    else if (highlightedParadaNoAuth) {
        titleHeader = `Paradas no autorizadas: ${highlightedParadaNoAuth}`;
    }
    //Unicamente tiene seleccionado vehiculo
    else if (highlightedAlertType) {
        titleHeader = `Paradas no autorizadas: ${filteredData[0].title}`;
    }
    //Ningun Filtro seleccionado
    else {
        titleHeader = `Paradas no autorizadas`;
    }



    const style = {
        display: "-webkit-box",
        WebkitLineClamp: 1, // Limita a 2 líneas
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    return (
        <Card className="h-100">
            <FalconCardHeader
                title={titleHeader}
                titleTag="h6"
                light
                endEl={
                    <>
                        {
                            highlightedAlertType &&
                            (
                                <IconButton
                                    onClick={handleFiltro}
                                    icon="times-circle"
                                    size="sm"
                                    variant="falcon-default">Remover filtro
                                </IconButton>
                            )
                        }

                        {/*<IconButton
                            className='ms-2'
                            onClick={() => setVerDetalle(!verDetalle)}
                            icon="eye"
                            size="sm"
                            variant="falcon-default">
                            {!verDetalle ? 'Ver detalle' : 'Ocultar detalle'}
                        </IconButton>*/}
                    </>
                }
            />
            <Card.Body as={Row}>
                {/* Grafico de tipo dona */}
                <Col xs={(4)} className="mb-xxl-1 align-content-center">
                    <ParadasNoAutorizadasVehiculoChart data={filteredData ?? top10Alertas} onSelectAlertType={onSelectAlertType} />
                </Col>
                <Col xs={8} hidden={!verDetalle}>
                    {/* Detalle alertas */}
                    <div className="overflow-auto pe-x1" style={{ maxHeight: '300px' }}>
                        <hr className="mx-ncard mb-0 d-md-none d-xxl-block" />
                        {top10Alertas.map((item, index) => {
                            let isLast = index === data.length - 1;
                            let highlighted = highlightedAlertType === item.id_vehiculo;
                            return (<div>
                                <Row
                                    className={classNames(
                                        'position-relative align-items-center py-2 g-0 flex-nowrap',
                                        { 'border-bottom border-200': !isLast },
                                        { 'text-danger fw-bold': highlighted }
                                    )} style={{ minWidth: '350px' }} href="#!" onClick={(e) => {
                                        e.preventDefault();
                                        onSelectAlertType(item.id_vehiculo)
                                    }}
                                >
                                    {obtenerIconoVehiculo(item.id_vehiculo, item.color_vehiculo)}
                                    <Col className="py-1 ps-x1">
                                        <Flex className="justify-content-between"  >
                                            <Row className='mx-0 px-0' style={{ width: '55%' }}>
                                                <Flex className={classNames(
                                                    'm-0 p-0 align-items-center text-truncate flex-grow-1 flex-nowrap',
                                                    { 'fw-bold': highlighted }
                                                )} tag="h6" style={{ ...style }}>
                                                    <a className={classNames('label-detail-card px-0 mx-0', {
                                                        'fw-bold': highlighted,
                                                    })}
                                                        style={{ fontSize: '14px', ...style, color: highlighted ? item.color : '#212121' }}
                                                        title={item.title}>
                                                        {item.title}
                                                    </a>
                                                </Flex>
                                            </Row>
                                            <Row className="flex-nowrap justify-content-between g-0" >

                                                <div className='ps-2 text-start m-0' style={{ width: '50%' }}>
                                                    <Badge pill bg="transparent" className=' mt-0'>
                                                        <div className="m-0 fs-10 fw-semibold" style={{ color: highlighted ? item.color : '#212121' }}>{item.target} No Autorizados</div>
                                                    </Badge>
                                                </div>
                                                <div className="ps-2 justify-content-end d-flex flex-nowrap" style={{ width: '50%' }}>

                                                    <Badge pill bg="200" className="my-1 text-primary" style={{ width: '60px' }}>
                                                        {item.amount}%
                                                    </Badge>
                                                    <a className="ps-2" style={{
                                                        color: highlighted ? item.color : 'inherit', width: '20px'
                                                    }}>
                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                    </a>
                                                </div>
                                            </Row>
                                        </Flex>
                                    </Col >
                                </Row >
                            </div >
                            )
                        })}
                    </div>
                </Col>
            </Card.Body>

            <Card.Footer className='py-2'>
                <Row className='justify-content-end'>
                    <Col md={3} className='text-center'>
                        <div className="form-col-label">Total de vehiculos</div>
                        <div className="fw-semibold form-col-label">{cantVehicles}</div>
                    </Col>
                </Row>
            </Card.Footer>
        </Card>
    );
};

ParadasNoAutorizadasVehiculo.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        id_vehiculo: PropTypes.string,
        icono_alerta: PropTypes.string
    })).isRequired,
    onSelectAlertType: PropTypes.func.isRequired, // 📌 Nueva función para seleccionar alertas
    highlightedAlertType: PropTypes.string // 📌 Estado de alerta seleccionada
};

export default ParadasNoAutorizadasVehiculo;
